<template>
    <tbody>
        <tr>
            <td>
                <ui-timeago class="tx-table__cell muted" v-bind:timestamp="time"/>
            </td>
            <td>
                <!-- <ui-link class="tx-table-cell-icon" v-bind:to="transactionRoute" >
                    <icon-tx-chain fill="none"/>
                </ui-link> -->
                <ui-link class="tx-table-cell tx-table-cell-link-badge" v-bind:to="transactionRoute" >
                    <div class="tx-table__cell">
                        <!--<div class="tx-table__badge tx-table__badge&#45;&#45;burn" v-if="!type">-->
                        <!--    <div class="tx-table__badge&#45;&#45;items">-->
                        <!--        <div class="tx-table__badge&#45;&#45;icon">-->
                        <!--            <icon-tx-burn />-->
                        <!--        </div>-->
                        <!--        <div class="tx-table__badge&#45;&#45;value">-->
                        <!--            {{ $t('nft.item.badge.burn') }}-->
                        <!--        </div>-->
                        <!--    </div>-->
                        <!--</div>-->

                        <div class="tx-table__badge tx-table__badge--sale" v-if="type === 'nft_put_on_sale' || type ==='nft_update_sale'">
                            <div class="tx-table__badge--items">
                                <div class="tx-table__badge--icon">
                                    <icon-tx-sale />
                                </div>
                                <div class="tx-table__badge--value">
                                    {{ $t('nft.item.badge.sale') }}
                                </div>
                            </div>
                        </div>

                        <div class="tx-table__badge tx-table-cell-icon--out" v-if="type === 'nft_transfer'">
                            <div class="tx-table__badge--items">
                                <div class="tx-table__badge--icon">
                                    <icon-tx-sent />
                                </div>
                                <div class="tx-table__badge--value">
                                    {{ $t('nft.item.badge.sent') }}
                                </div>
                            </div>
                        </div>

                        <div class="tx-table__badge tx-table__badge--bid" v-if="type === 'teleitem_start_auction' || type === 'nft_put_on_auction' || type === 'dns_release'">
                            <div class="tx-table__badge--items">
                                <div class="tx-table__badge--icon">
                                    <icon-tx-bid />
                                </div>
                                <div class="tx-table__badge--value">
                                    {{ $t('nft.item.badge.auction') }}
                                </div>
                            </div>
                        </div>

                        <div class="tx-table__badge tx-table__badge--bid" v-if="type === 'auction_bid'">
                            <div class="tx-table__badge--items">
                                <div class="tx-table__badge--icon">
                                    <icon-tx-bid />
                                </div>
                                <div class="tx-table__badge--value">
                                    {{ $t('nft.item.badge.bid') }}
                                </div>
                            </div>
                        </div>

                        <div class="tx-table__badge tx-table-cell-icon--in" v-if="type === 'nft_mint' || type === 'deploy_nft'">
                            <div class="tx-table__badge--items">
                                <div class="tx-table__badge--icon">
                                    <icon-tx-mint />
                                </div>
                                <div class="tx-table__badge--value">
                                    {{ $t('nft.item.badge.mint') }}
                                </div>
                            </div>
                        </div>

                        <div class="tx-table__badge tx-table-cell-icon--out" v-if="type === 'nft_cancel_sale'">
                            <div class="tx-table__badge--items">
                                <div class="tx-table__badge--icon">
                                    <icon-tx-cancel />
                                </div>
                                <div class="tx-table__badge--value">
                                    {{ $t('nft.item.badge.cancel') }}
                                </div>
                            </div>
                        </div>

                        <div class="tx-table__badge tx-table-cell-icon--out" v-if="type === 'teleitem_cancel_auction' || type === 'nft_cancel_auction' || type === 'nft_finish_auction'">
                            <div class="tx-table__badge--items">
                                <div class="tx-table__badge--icon">
                                    <icon-tx-cancel-bid />
                                </div>
                                <div class="tx-table__badge--value">
                                    {{ $t('nft.item.badge.cancel') }}
                                </div>
                            </div>
                        </div>

                        <div class="tx-table__badge tx-table__badge--sold" v-if="type === 'nft_purchase' || type === 'dns_purchase'">
                            <div class="tx-table__badge--items">
                                <div class="tx-table__badge--icon">
                                    <icon-tx-sold />
                                </div>
                                <div class="tx-table__badge--value">
                                    {{ $t('nft.item.badge.sold') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </ui-link>
            </td>

            <td>
                <div class="tx-table__cell">
                    <template v-if="from">
                        <nft-history-address v-bind:address="from" />
                    </template>

                    <div class="tx-table-action-icon" v-if="from && to">
                        <arrow-right />
                    </div>

                    <template v-if="to">
                        <nft-history-address v-bind:address="to" />
                    </template>
                </div>
            </td>

            <td>
                <span class="tx-table__cell tx-table__cell--align-center nft-table-marketplace" v-if="marketplace">
                    <marketplace-fragment v-if="marketplace === 'fragment'" />
                    <marketplace-getgems v-if="marketplace === 'getgems'" />
                    <marketplace-marketapp v-if="marketplace === 'marketapp'" />
                    {{ marketplace }}
                </span>
            </td>

            <td>
                <span class="tx-table__cell tx-table__cell--align-right" v-if="price">
                    <span class="tx-table-price-ton">
                        {{ $ton(price) }} TON
                    </span>
                    <template v-if="price">
                        <span v-if="$store.state.exchangeRate" style="color: #717579">
                            ≈ <ui-fiat v-bind:tonValue="price"/>
                        </span>
                    </template>
                </span>
            </td>
        </tr>
    </tbody>
</template>

<script>
// import IconTxChain from '@img/icons/tonscan/chain-16.svg?vue';
import IconTxSale from '@img/icons/tonscan/badges/sale.svg?vue';
import IconTxSent from '@img/icons/tonscan/badges/sent.svg?vue';
import IconTxBid from '@img/icons/tonscan/badges/bid.svg?vue';
import IconTxMint from '@img/icons/tonscan/badges/mint.svg?vue';
import IconTxSold from '@img/icons/tonscan/badges/sold.svg?vue';
import IconTxCancel from '@img/icons/tonscan/badges/cancel.svg?vue';
import IconTxCancelBid from '@img/icons/tonscan/badges/cancel-bid.svg?vue';
import ArrowRight from '@img/icons/tonscan/arrow-small-right.svg?vue';
import MarketplaceFragment from '@img/icons/marketplaces/fragment.svg?vue';
import MarketplaceGetgems from '@img/icons/marketplaces/getgems.svg?vue';
import MarketplaceMarketapp from '@img/icons/marketplaces/marketapp.svg?vue';
import NftHistoryAddress from '~/components/nft/NftHistoryAddress.vue';

export default {
    props: {
        hash: String,
        time: Number,
        from: String,
        to: String,
        price: String,
        type: String,
        marketplace: String,
    },

    computed: {
        transactionRoute() {
            return {
                name: 'tx',
                params: {
                    hash: this.hash,
                },
            };
        },
    },

    components: {
        NftHistoryAddress,
        // IconTxChain,
        // IconTxBurn,
        IconTxSale,
        IconTxSent,
        IconTxBid,
        IconTxMint,
        IconTxCancel,
        IconTxCancelBid,
        IconTxSold,
        ArrowRight,
        MarketplaceFragment,
        MarketplaceGetgems,
        MarketplaceMarketapp,
    },
};
</script>
<style lang="scss">
.tx-table-cell-link-badge,
.tx-table-cell-link-badge:hover {
    text-decoration: none;
}

.tx-table-price-ton {
    margin-right: 4px;
}
.nft-table-marketplace {
    font-weight: 500;
    text-transform: capitalize;

    svg {
        width: 13px;
        height: 13px;
        margin-right: 4px;
    }
}
</style>
